module.exports = __webpack_public_path__ + "static/media/cert-itechlab-white.e2abe2f1.svg";